<template>
  <div class="UserEdit" v-title data-title="同步规则设置">
    <div class="row bc-white fs3 pt5 pb5">
      <div class="pl1">店铺名称：</div>
      <div class="flex-1 pl5 text-left">
        {{storeinfo.name}}
      </div>
    </div>
    <!-- <div class="row bc-white fs3 pt5 pb5">
      <div class="pl1">价格来源：</div>
      <div class="flex-1 pl5 pr10">
        <van-uploader
          class="col"
          width="100%"
          height="105"
          v-model="fileList"
          multiple
          :max-count="1"
          :after-read="afterRead"
          :preview-full-image="false"
          image-fit="cover"
          @delete="deleteImage"
        />
      </div>
    </div> -->
    <table class="table-rule">
      <tr>
        <th width="35%">行话</th>
        <th>同步</th>
        <th width="40%">递减规则</th>
      </tr>
      <tr v-for="data in ruleData.rules" :key="data.categoryCode">
        <td>{{data.categoryName}}</td>
        <td>
          <van-switch :size="20" v-model="data.sync" inactive-color="#eee" @change="changeSwitch(data)"/>
        </td>
        <td>
          <van-field v-model="data.subtract" placeholder="请输入数字" />
        </td>
      </tr>
    </table>
    <div class="save pt7 pb7">
      <van-button @click="saveRule" class="btn-common" size="small" type="info">保存</van-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  sendRequest, storeGet, getSyncRule, saveSyncRule,
} from '../../network/NetworkAccessor';
// import storage from '../uitls/cacheUtil';
import config from '../../config';

export default Vue.extend({
  name: 'UserEdit',
  components: {},
  data() {
    return {
      fileDomain: config.FILE_DOMAIN,
      loading: false,
      fileList: [],
      storeinfo: {},
      ruleData: {},
    };
  },
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  methods: {
    changeSwitch(data) {
      if (!data.sync) {
        this.$set(data, 'subtract', '');
      }
    },
    formatFileList() {
      this.fileList = [{
        url: this.fileDomain + this.storeinfo.qrcode,
      }];
    },
    deleteImage() {
      this.$set(this.storeinfo, 'qrcodeFile', '');
      this.$set(this.storeinfo, 'qrcode', '');
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
      this.$set(this.storeinfo, 'qrcode', '');
      this.$set(this.storeinfo, 'qrcodeFile', file.file);
    },
    // saveImage() {
    //   const params = new FormData();
    //   Object.entries(this.storeinfo).forEach(([key, value]) => {
    //     if (value) {
    //       params.append(key, value);
    //     }
    //   });
    //   console.log(this.storeinfo);
    //   const methodName = this.storeinfo.id ? storeUpdate : storeAdd;
    //   return upload(methodName, params);
    // },
    saveRule() {
      const rules = this.ruleData.rules.filter(d => d.sync);
      if (rules.some(d => !d.subtract && d.subtract !== 0)) {
        this.$dialog.alert({
          message: '开启同步的行话，需要补充递减规则',
        });
        return;
      }
      sendRequest(saveSyncRule, {
        userId: this.id,
        rules,
        id: this.ruleData.id,
      }).then((res) => {
        this.$dialog.alert({
          message: '操作成功',
        });
        this.$router.push('/home');
      }).catch((e) => {
        this.$dialog.alert({
          message: e.message,
        });
      });
    },
    getStore() {
      if (!this.id) {
        return;
      }
      sendRequest(storeGet, { userId: this.id }).then((res) => {
        console.log(res);
        const storeinfo = res || {};
        this.storeinfo = storeinfo;
      }).catch((e) => {
      }).then(() => {
        this.formatFileList();
      });
    },
    getSyncRule() {
      return sendRequest(getSyncRule, { userId: this.id }).then((res = {}) => {
        this.ruleData = res || [];
      }).catch((e) => {
        console.error(e);
      });
    },
  },
  created() {
    this.getStore();
    this.getSyncRule();
  },
});
</script>
<style scoped>
  .UserEdit {
    min-height: 100vh;
    padding: 5px;
  }
  .table-rule {
    width: 100%;
    border: 1px solid #1e67c7;
    border-spacing: 0;
  }
  .table-rule th {
    border-left: 1px solid #1e67c7;
    color: #1e67c7;
  }
  .table-rule th:first-child {
    border-left: 0;
  }
  .table-rule td {
    border-left: 1px solid #1e67c7;
    border-top: 1px solid #1e67c7;
    color: #1e67c7;
  }
  .table-rule td:first-child {
    border-left: 0;
  }
  .table-rule >>> .van-field {
    padding: 5px 5px;
  }
</style>
